import { createContext } from 'react';

export const MapBuilderContext = createContext({
	filter: {},
	setFilter: () => {},
	plots: [],
	updatePlotPath: () => {},
});

export const ExpandableRowContext = createContext({
	path: [],
	setPath: () => {},
	plot: null,
	onSave: () => {},
	mode: null,
	setMode: () => {},
	onDeleteClick: () => {},
	onAddClick: () => {},
});
